import { render, staticRenderFns } from "./SubMain.vue?vue&type=template&id=4a6118d0"
import script from "./SubMain.vue?vue&type=script&lang=js"
export * from "./SubMain.vue?vue&type=script&lang=js"
import style0 from "./SubMain.vue?vue&type=style&index=0&id=4a6118d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports